function apiReducer(state = { callers: [] }, action = {}) {
  let newCallers
  switch (action.type) {
    case 'ADD_API_CALLER':
      newCallers = [...state.callers]
      if (newCallers.indexOf(action.ref) === -1) {
        newCallers.push(action.ref)
      }
      return {
        ...state,
        callers: newCallers
      }
    case 'CANCEL_PENDING_API_CALLBACKS':
      // remove the caller from the list if it exists
      return {
        ...state,
        callers: state.callers.filter(caller => caller !== action.ref)
      }
    default:
      return state
  }
}

export default apiReducer
